import React from 'react';

function FaqSidebar({sections}) {

    return (
        <div className="blog2-sidebar">
            <p className="blog2-sidebar-text">
                Najczęściej zadawane przez Was pytania, znajdziesz odpowiedzi poniżej.
                Jeśli będziesz miał dodatkowe pytania - zapraszamy do kontaktu.
            </p>

            <ul className="blog2-categories-list">
                <li>
                    <a href="#faq-top" className="faq2-category-link faq2-category-link--active">
                        Wszystkie kategorie
                    </a>
                </li>
                {sections.map(section => (
                    <li key={section.id}>
                        <a href={`#${section.id}`} className="faq2-category-link">{section.title}</a>
                        {section.children.length > 0 && (
                            <ul className="faq2-subcategories-list">
                                {section.children.map(child => (
                                    <li key={child.id}>
                                        <a href={`#${child.id}`} className="faq2-subcategory-link">{child.title}</a>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default FaqSidebar;
